// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8DDsm","colBig":"styles_colBig__3mlrJ","colSmall":"styles_colSmall__3TVkU"};